import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the historical cash flow view.
 * @extends JetView
 */
export default class tableHistoricalCashFlowView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the node with the sum of values.
                 * @param {Object} master - The master view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node's inner HTML
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            view: 'treetable', // Treetable view
            scheme: {
                $group: {
                    by: 'Concessionaire', // Grouping by Concessionaire
                },
            },
            bready: function () {
                this.openAll(); // Open all rows by default
            },
            footer: true, // Enable footer
            columns: [
                {
                    id: 'Id',
                    header: 'Id',
                    width: 250,
                    /**
                     * Template for rendering Id column.
                     * @param {Object} obj - The data object.
                     * @param {Object} common - Common utilities.
                     * @returns {String} Rendered Id or group value.
                     */
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group value
                        return obj.Id; // Render Id
                    },
                },
                {
                    id: 'AssociateUser',
                    header: _('Usuario Asociado'), // Localized header
                    width: 300,
                },
                {
                    id: 'Concessionaire',
                    header: _('Concesionario'), // Localized header
                    width: 300,
                },
                {
                    id: 'Subconcessionaire',
                    header: _('Subconcesionario'), // Localized header
                    width: 300,
                },
                {
                    id: 'IsPointSale',
                    header: _('Es Punto de Venta?'), // Localized header
                    width: 300,
                },
            ],
            autowidth: false, // Disable auto width
            data: [
                // Initial data for the treetable
                {
                    Id: '1127',
                    AssociateUser: 'ADSWEB',
                    Concessionaire: 'ADS',
                    Subconcessionaire: '',
                    IsPointSale: 'Si',
                },
                {
                    Id: '1125',
                    AssociateUser: 'PV Argentina',
                    Concessionaire: 'Conce Argentina',
                    Subconcessionaire: '',
                    IsPointSale: 'Si',
                },
                {
                    Id: '1066',
                    AssociateUser: 'pycol',
                    Concessionaire: 'concecol',
                    Subconcessionaire: '',
                    IsPointSale: 'Si',
                },
            ],
            math: true, // Enable math operations
            datafetch: 10, // Number of records to fetch
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        // Event listener for filtering based on concessionaire
        this.on(this.app, 'concessionaire:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Append dateFrom
                        string1 = string1 + '&dateTo=' + date[1]; // Append dateTo
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append formatted start date
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append formatted end date
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load grid data with filters
            );
        });

        // Event listener for item click to trigger user ID event
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection to load data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data with PlayerId filter
            );
        });
    }
}

// FILE DOCUMENTED
